import * as React from 'react'

import Hot from './hot'
import BestRated from './best-rated'
import Genre from './genre'
import Mood from './mood'
import ChevronRight from './chevron-right'

interface ICategoryIcons {
  [key: string]: any
}

export const BannerIcons: ICategoryIcons = {
  hot: <Hot />,
  best_rated: <BestRated />
}

export const TabbedTableIcons: ICategoryIcons = {
  genre: <Genre />,
  mood: <Mood />,
  chevron_right: <ChevronRight />
}
